import { useEffect, useState } from 'react';
import { getAllCategories } from '../../utils/utils';
import Loading from '../Loading';

let Filters = ({
  filters,
  setFilters,
  postType,
  setPostType,
  sortBy,
  setSortBy,
}) => {
  let documentTypeCategoryIds = [11, 5, 9, 10];
  let [categories, setCategories] = useState([]);
  let [filteredCategories, setFilteredCategories] = useState([]);
  let [documentTypes, setDocumentTypes] = useState([]);
  let [selectedCategories, setSelectedCategories] = useState(filters);
  let [loading, setLoading] = useState(false);
  let [displayFilters, setDisplayFilters] = useState(false);

  useEffect(() => {
    async function fetch() {
      setLoading(true);
      let categories = await getAllCategories();
      setCategories(categories);
      setLoading(false);
    }
    fetch();
  }, []);

  useEffect(() => {
    // Update the categories string in the filters state.
    setFilters(selectedCategories);
  }, [selectedCategories]);

  useEffect(() => {
    // On load we want to filter categories so we can display two separate lists.
    let documentTypes = categories.filter((category) =>
      documentTypeCategoryIds.includes(category.id)
    );
    let filteredCategories = categories.filter(
      (category) => !documentTypeCategoryIds.includes(category.id)
    );

    setFilteredCategories(filteredCategories);
    setDocumentTypes(documentTypes);
  }, [categories]);

  // Set the post type in the filtering state.

  return (
    <div className="py-4">
      <div>
        <button
          onClick={() => {
            setDisplayFilters(!displayFilters);
          }}
          className="button display-filters-button uw-button"
        >
          Filters
        </button>
      </div>
      {displayFilters && (
        <div id="searchlib-filters-outer">
          <h4>Filter Results</h4>
          {/*iterate through the categories and display them as checkboxes*/}
          {loading && <Loading />}
          <h5>Categories</h5>
          <CategoriesFilters
            categories={filteredCategories}
            selectedCategories={selectedCategories}
            setSelectedCategories={setSelectedCategories}
            postType={postType}
            setPostType={setPostType}
          />
          <h5>Document Types</h5>
          <CategoriesFilters
            categories={documentTypes}
            selectedCategories={selectedCategories}
            setSelectedCategories={setSelectedCategories}
            postType={postType}
            setPostType={setPostType}
          />
          <Sort sortBy={sortBy} setSortBy={setSortBy} />
        </div>
      )}
    </div>
  );
};

let CategoriesFilters = ({
  categories,
  selectedCategories,
  setSelectedCategories,
  postType,
  setPostType,
}) => {
  return (
    <div className="grid grid-cols-3 my-5 gap-x-8 gap-y-3">
      {categories.map((category) => {
        if (category.name === 'Featured') return null;
        return (
          <div
            className="flex items-center lg:col-span-1 col-span-3"
            key={category.id}
          >
            <CategoryCheckbox
              category={category}
              selectedCategories={selectedCategories}
              setSelectedCategories={setSelectedCategories}
            />
          </div>
        );
      })}
    </div>
  );
};

let CategoryCheckbox = ({
  category,
  selectedCategories,
  setSelectedCategories,
}) => {
  let [checkboxState, setCheckboxState] = useState(
    selectedCategories.includes(category.id.toString()) ? true : false
  );

  let handleCheckboxChange = (e) => {
    if (e.target.checked) {
      setCheckboxState(true);
      setSelectedCategories([...selectedCategories, e.target.value]);
    } else {
      // create copy of selectedCategories
      // remove the category that was unchecked
      // set the selectedCategories state to the new array
      let newSelectedCategories = [...selectedCategories];
      let index = newSelectedCategories.indexOf(e.target.value);
      if (index > -1) {
        newSelectedCategories.splice(index, 1);
      }
      setCheckboxState(false);
      setSelectedCategories(newSelectedCategories || []);
    }
  };

  return (
    <>
      <input
        type="checkbox"
        className="mb-0"
        id={category.id}
        name={category.name}
        checked={checkboxState}
        value={category.id}
        onChange={handleCheckboxChange}
      />
      <span className="ml-3">{category.name}</span>
    </>
  );
};

let PostTypeSelector = ({ postType, setPostType }) => {
  let [resoucesChecked, setResourcesChecked] = useState(
    postType.includes('resource') ? true : false
  );
  let [postsChecked, setPostsChecked] = useState(
    postType.includes('post') ? true : false
  );

  let handleCheckboxChange = (e) => {
    if (e.target.checked) {
      // Push it to the postType array
      if (e.target.name === 'post') {
        setPostsChecked(true);
      }
      if (e.target.name == 'resource') {
        setResourcesChecked(true);
      }
      setPostType([...postType, e.target.value]);
    } else {
      // remove it from the post type array if it is unchecked.

      if (e.target.name === 'post') {
        setPostsChecked(false);
      }
      if (e.target.name == 'resource') {
        setResourcesChecked(false);
      }

      let newPostType = [...postType];
      let index = newPostType.indexOf(e.target.value);
      if (index > -1) {
        newPostType.splice(index, 1);
      }
      setPostType(newPostType || []);
    }
  };

  return (
    <>
      <div className="flex items-center lg:col-span-1 col-span-3">
        <input
          type="checkbox"
          className="mb-0"
          id="post"
          name="post"
          value="post"
          checked={postsChecked}
          onChange={handleCheckboxChange}
        />
        <span className="ml-3">Guidebooks & Guidebook Chapters</span>
      </div>
      <div className="flex items-center lg:col-span-1 col-span-3">
        <input
          type="checkbox"
          id="resource"
          className="mb-0"
          name="resource"
          checked={resoucesChecked}
          value="resource"
          onChange={handleCheckboxChange}
        />
        <span className="ml-3">Resource</span>
      </div>
    </>
  );
};

let Sort = ({ sortBy, setSortBy }) => {
  return (
    <div onChange={(e) => setSortBy(e.target.value)}>
      <h4>Sort</h4>
      <div className="my-5">
        <div className="flex items-center">
          <input
            type="radio"
            id="relevance"
            name="sort"
            value="relevance"
            onChange={() => true}
            checked={sortBy === 'relevance'}
          />
          <div className="ml-3">Relevance</div>
        </div>
        <div className="flex items-center">
          <input
            type="radio"
            id="date"
            name="sort"
            value="date"
            onChange={() => true}
            checked={sortBy === 'date'}
          />
          <div className="ml-3">Publish Date (Most recent first)</div>
        </div>
        <div className="flex items-center">
          <input
            type="radio"
            id="date"
            name="sort"
            value="modified"
            onChange={() => true}
            checked={sortBy === 'modified'}
          />
          <div className="ml-3">Updated Date (Most recent first)</div>
        </div>
      </div>
    </div>
  );
};
export default Filters;
